//
// Bonus Multiview Collection
// --------------------------

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var BonusMultiView = require('../bonusmultiview.bonus.collection');

    module.exports = BonusMultiView.extend({
        _requestBonusList: function(bonusTypes) {
            var request = {
                ID: 31143,
                responses: [31144, 31145],
                description: 'Search Player Available Bonus Templates',
                triggerTypes: [],
                pageSize: 450
            };
            var promoCodes = [];

            bonusTypes.forEach(function(bonusType) {
                switch (bonusType) {
                    case 'free':
                        if (this.bonusesPrefs.bonusFreeCode && this.bonusesPrefs.bonusFreeCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusFreeCode);
                        }
                        break;
                    case 'optIn':
                        if (this.bonusesPrefs.bonusOptInCode && this.bonusesPrefs.bonusOptInCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusOptInCode);
                        }
                        break;
                    case 'buyIn':
                        request.triggerTypes.push('buybonus');
                        break;
                    case 'deposit':
                        request.triggerTypes.push('deposit');
                        break;
                    case 'campaign':
                        request.triggerTypes.push('campaign');
                        break;
                }
            }.bind(this));

            if (promoCodes.length) {
                request.triggerTypes.push('promotioncode');

                if (promoCodes.length > 1) {
                    return $.when(
                        this.getBonusTemplates({ ...request, promotionCode: promoCodes[0] }),
                        this.getBonusTemplates({ ...request, promotionCode: promoCodes[1] })
                    );
                }

                return this.getBonusTemplates(_.extend(request, { promotionCode: promoCodes[0] }));
            }

            return this.getBonusTemplates(request);
        }
    });
});
